import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  InputBase,
  Paper
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Add as AddIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import UploadIcon from '@mui/icons-material/Upload';
import { colors } from '../../utils/colors';
import { useNavigate, useParams } from 'react-router-dom';
import ProcurementList from './ProcurementList';
import ProcurementDetails from './ProcurementDetails';
import AddProcurement from './AddProcurement';

const Procurements = ({ customerId, projectId, projectName, onBack }) => {
  const [selectedProcurement, setSelectedProcurement] = useState(null);
  const [showAddProcurement, setShowAddProcurement] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const params = useParams();
  const routeCustomerId = params.id;
  const routeProjectId = params.projectId;
  const routeProcurementId = params.procurementId;

  const handleProcurementClick = (procurement) => {
    setSelectedProcurement(procurement);
    const cId = customerId || routeCustomerId;
    const pId = projectId || routeProjectId;
    navigate(`/customers/${cId}/project/${pId}/procurements/${procurement.id}`);
  };

  const handleBackToList = () => {
    setSelectedProcurement(null);
    setShowAddProcurement(false);
    const cId = customerId || routeCustomerId;
    const pId = projectId || routeProjectId;
    navigate(`/customers/${cId}/project/${pId}/procurements`);
  };

  const handleAddProcurement = () => {
    setShowAddProcurement(true);
  };

  const handleSubmitProcurement = (formData) => {
    setShowAddProcurement(false);
  };

  const handleUpload = () => {
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  if (showAddProcurement) {
    return (
      <AddProcurement
        customerId={customerId}
        projectId={projectId}
        onBack={handleBackToList}
        onSubmit={handleSubmitProcurement}
      />
    );
  }

  if (routeProcurementId || selectedProcurement) {
    return (
      <ProcurementDetails
        customerId={customerId || routeCustomerId}
        projectId={projectId || routeProjectId}
        procurementId={routeProcurementId || (selectedProcurement && selectedProcurement.id)}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Box sx={{ p: { xs: 1.5, sm: 2, md: 2.5 }, bgcolor: '#ffffff', minHeight: 'auto' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          mb: { xs: 2.5, sm: 3 },
          gap: { xs: 2, sm: 2.5 }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1.5, sm: 2 }
          }}
        >
          {(onBack || routeCustomerId) && (
            <IconButton
              onClick={() => {
                if (onBack) return onBack();
                const cId = customerId || routeCustomerId;
                const pId = projectId  || routeProjectId;
                navigate(`/customers/${cId}/project/${pId}`);
              }}
              sx={{
                color: colors.primary.main,
                bgcolor: colors.background.hover,
                '&:hover': {
                  bgcolor: colors.primary.light + '20'
                },
                width: { xs: 36, sm: 40 },
                height: { xs: 36, sm: 40 }
              }}
            >
              <ArrowBackIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
            </IconButton>
          )}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: colors.text.primary,
              fontSize: { xs: '1.375rem', sm: '1.625rem', md: '1.875rem', lg: '2rem' }
            }}
          >
            Procurements
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1.5, sm: 2 },
            alignItems: { xs: 'stretch', sm: 'center' },
            width: { xs: '100%', md: 'auto' },
            flexShrink: 0
          }}
        >
          {/* <Paper
            component="form"
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: { xs: '100%', sm: '100%', md: '300px', lg: '350px' },
              bgcolor: colors.background.secondary,
              border: `1px solid ${colors.border.main}`,
              borderRadius: 2,
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.75, sm: 0.875 },
              boxShadow: 'none',
              height: { xs: 42, sm: 44 },
              '&:hover': {
                borderColor: colors.primary.main
              },
              '&:focus-within': {
                borderColor: colors.primary.main,
                boxShadow: `0 0 0 2px ${colors.primary.main}20`
              }
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <SearchIcon sx={{ color: colors.text.secondary, mr: 1, fontSize: { xs: 20, sm: 22 } }} />
            <InputBase
              placeholder="Search procurements..."
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{
                flex: 1,
                fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                color: colors.text.primary,
                '&::placeholder': {
                  color: colors.text.secondary,
                  opacity: 1
                }
              }}
            />
          </Paper> */}

          {/* <Box
            sx={{
              display: 'flex',
              gap: { xs: 1, sm: 2 },
              flexDirection: { xs: 'row', sm: 'row' },
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'stretch', sm: 'flex-start' }
            }}
          >
            <Button
              variant="outlined"
              onClick={handleUpload}
              sx={{
                borderColor: colors.border.main,
                color: colors.text.secondary,
                minWidth: 0,
                padding: { xs: 1, sm: 1.25 },
                borderRadius: 2,
                height: { xs: 42, sm: 44 },
                width: { xs: 42, sm: 44 },
                '&:hover': {
                  borderColor: colors.primary.main,
                  bgcolor: colors.background.hover,
                  color: colors.primary.main
                }
              }}
            >
              <UploadIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
            </Button>

            <Button
              variant="contained"
              // startIcon={<AddIcon sx={{ fontSize: { xs: 18, sm: 19, md: 20 } }} />}
              onClick={handleAddProcurement}
              sx={{
                bgcolor: colors.primary.main,
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                px: { xs: 1.5, sm: 2, md: 2.5 },
                py: { xs: 1, sm: 1.125 },
                fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                flex: { xs: 1, sm: 0 },
                minWidth: { xs: 'auto', sm: 160 },
                width: { xs: '100%', sm: 'auto' },
                height: { xs: 42, sm: 44 },
                whiteSpace: 'nowrap',
                boxShadow: `0 4px 12px ${colors.primary.main}40`,
                '&:hover': {
                  bgcolor: colors.primary.dark,
                  boxShadow: `0 6px 16px ${colors.primary.main}50`
                },
                '& .MuiButton-startIcon': {
                  marginRight: { xs: 0.5, sm: 0.75 },
                  marginLeft: 0
                }
              }}
            >
              <Box
                component="span"
                sx={{
                  display: { xs: 'none', sm: 'inline' }
                }}
              >
                Add Procurements
              </Box>
              <Box
                component="span"
                sx={{
                  display: { xs: 'inline', sm: 'none' }
                }}
              >
                Add
              </Box>
            </Button>
          </Box> */}
        </Box>
      </Box>

      <ProcurementList
        customerId={customerId || routeCustomerId}
        projectId={projectId || routeProjectId}
        onProcurementClick={handleProcurementClick}
        searchQuery={searchQuery}
      />
    </Box>
  );
};

export default Procurements;